var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMmevent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m55 59h-46c-3.86 0-7-3.14-7-7v-42c0-.55.45-1 1-1h9v2h-8v41c0 2.76 2.24 5 5 5h46c2.76 0 5-2.24 5-5v-41h-8v-2h9c.55 0 1 .45 1 1v42c0 3.86-3.14 7-7 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 9h11v2h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 9h11v2h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 17h58v2h-58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 16c-2.21 0-4-1.79-4-4v-3c0-2.21 1.79-4 4-4s4 1.79 4 4v3c0 2.21-1.79 4-4 4zm0-9c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2s2-.9 2-2v-3c0-1.1-.9-2-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 16c-2.21 0-4-1.79-4-4v-3c0-2.21 1.79-4 4-4s4 1.79 4 4v3c0 2.21-1.79 4-4 4zm0-9c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2s2-.9 2-2v-3c0-1.1-.9-2-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 16c-2.21 0-4-1.79-4-4v-3c0-2.21 1.79-4 4-4s4 1.79 4 4v3c0 2.21-1.79 4-4 4zm0-9c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2s2-.9 2-2v-3c0-1.1-.9-2-2-2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m40.65 51c-.15 0-.3-.03-.44-.1l-8.21-4.05-8.21 4.05c-.34.17-.74.13-1.04-.1s-.45-.61-.38-.98l1.55-8.5-6.59-6.03c-.29-.26-.4-.67-.28-1.04s.44-.64.82-.69l9.16-1.25 4.09-7.77c.35-.66 1.42-.66 1.77 0l4.09 7.77 9.16 1.25c.38.05.7.32.82.69s0 .77-.28 1.04l-6.59 6.03 1.55 8.5c.07.37-.08.75-.38.98-.18.13-.39.2-.6.2zm-8.65-6.27c.15 0 .3.03.44.1l6.87 3.39-1.29-7.09c-.06-.34.05-.68.31-.92l5.43-4.97-7.56-1.03c-.32-.04-.6-.24-.75-.53l-3.44-6.54-3.44 6.54c-.15.29-.43.48-.75.53l-7.56 1.03 5.43 4.97c.25.23.37.58.31.92l-1.29 7.09 6.87-3.39c.14-.07.29-.1.44-.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmevent);
export default __webpack_public_path__ + "static/media/mmevent.35007cdb35168b93d10882b3a4c35030.svg";
export { ForwardRef as ReactComponent };